export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SORT = 'name asc';

// Websocket Channels
export const JOB_PROCESS_CHANNEL = 'JobProcessChannel';
